export const Details = ({ width = '30', height = '31' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 21.5C5.32843 21.5 6 22.1716 6 23C6 23.8284 5.32843 24.5 4.5 24.5C3.67157 24.5 3 23.8284 3 23C3 22.1716 3.67157 21.5 4.5 21.5ZM25.5 21.5C26.3284 21.5 27 22.1716 27 23C27 23.8284 26.3284 24.5 25.5 24.5H10.5C9.67157 24.5 9 23.8284 9 23C9 22.1716 9.67157 21.5 10.5 21.5H25.5ZM4.5 14C5.32843 14 6 14.6716 6 15.5C6 16.3284 5.32843 17 4.5 17C3.67157 17 3 16.3284 3 15.5C3 14.6716 3.67157 14 4.5 14ZM25.5 14C26.3284 14 27 14.6716 27 15.5C27 16.3284 26.3284 17 25.5 17H10.5C9.67157 17 9 16.3284 9 15.5C9 14.6716 9.67157 14 10.5 14H25.5ZM4.5 6.5C5.32843 6.5 6 7.17157 6 8C6 8.82843 5.32843 9.5 4.5 9.5C3.67157 9.5 3 8.82843 3 8C3 7.17157 3.67157 6.5 4.5 6.5ZM25.5 6.5C26.3284 6.5 27 7.17157 27 8C27 8.82843 26.3284 9.5 25.5 9.5H10.5C9.67157 9.5 9 8.82843 9 8C9 7.17157 9.67157 6.5 10.5 6.5H25.5Z"
        fill="white"
      />
    </svg>
  );
};
